import { CellContext } from '@tanstack/react-table';
import { CellLink } from '@/components/table/_fieldDefinitions/_base/CellLink.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { SimpleNestedTour } from '@/features/dashboard/tours/types/SimpleNestedTour.ts';

export const nestedTourFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as SimpleNestedTour | null | undefined;
  if (!value) return <EmptyValue />;
  return (
    <CellLink
      to="/app/tours/$tourId"
      params={{ tourId: value.id }}
      importance={info.column.columnDef.meta?.importance}
    >
      {value.name}
    </CellLink>
  );
};
